// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"BuildControl__BuildControl__1eM2F","Wrapper":"BuildControl__Wrapper__3LZuA","PlusMinus":"BuildControl__PlusMinus__3fGmW","controller":"BuildControl__controller__8azbL","disabled":"BuildControl__disabled__1NSuy","controlNumber":"BuildControl__controlNumber__1Esev"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/Build Control/BuildControl.css
// module id = 145
// module chunks = 0